export default "__VITE_ASSET__CfqinLAc__"